"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCardPaymentTokenizationValid = exports.CardType = exports.PaymentMethod = void 0;
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["credit"] = "Credit Card";
    // debit = "Debit Card", // D-002 remove debit card option from the dropdown
    PaymentMethod["check"] = "Check";
    PaymentMethod["cash"] = "Cash";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
var CardType;
(function (CardType) {
    CardType["visa"] = "Visa";
    CardType["master"] = "Mastercard";
    CardType["amex"] = "American Express";
    CardType["discover"] = "Discover";
})(CardType = exports.CardType || (exports.CardType = {}));
/** New cards require a CardSecure token and must not include raw card fields. */
exports.isCardPaymentTokenizationValid = (payment, profileID) => {
    if (String(profileID || "0") !== "0")
        return true;
    const hasToken = !!String(payment.cardToken || "").trim();
    const hasRawCardData = !!String(payment.cardNumber || "").trim() ||
        !!String(payment.cardExpiry || "").trim() ||
        !!String(payment.cardCvv || "").trim();
    return hasToken && !hasRawCardData;
};



//////////////////
// WEBPACK FOOTER
// ./src/shared/payment.ts
// module id = 3387
// module chunks = 0